import React from 'react';
import { motion } from 'framer-motion';

const ValueProps = () => {
  const props = [
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Fast Delivery",
      gradient: "from-blue-400 to-cyan-500",
      iconColor: "text-blue-400"
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: "Security First",
      gradient: "from-indigo-400 to-violet-500",
      iconColor: "text-indigo-400"
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
        </svg>
      ),
      title: "Scalable Solutions",
      gradient: "from-emerald-400 to-teal-500",
      iconColor: "text-emerald-400"
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Ongoing Support",
      gradient: "from-purple-400 to-indigo-500",
      iconColor: "text-purple-400"
    }
  ];

  return (
    <div className="w-auto mt-8">
      <div className="grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:gap-4">
        {props.map((prop, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 * index }}
            className="flex items-center gap-2.5 group"
          >
            <div className={`${prop.iconColor} group-hover:scale-110 transition-transform duration-300`}>
              {prop.icon}
            </div>
            <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors duration-300">
              {prop.title}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ValueProps;
